'use strict';

var React = require('react');
var router = require('@reach/router');
var experience_jsReact = require('@ninetailed/experience.js-react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const usePrevious = value => {
  const ref = React.useRef();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
const Executor = ({
  location,
  onRouteChange
}) => {
  const ninetailed = experience_jsReact.useNinetailed();
  const previousHref = usePrevious(location.href);
  React.useEffect(() => {
    if (location.href !== previousHref) {
      if (typeof onRouteChange === 'function') {
        onRouteChange({
          isInitialRoute: !previousHref,
          url: location.href
        }, ninetailed);
      } else {
        ninetailed.page();
      }
    }
  }, [location.href, previousHref, ninetailed, onRouteChange]);
  return null;
};
const Tracker = ({
  onRouteChange
}) => {
  return /*#__PURE__*/React__default["default"].createElement(router.Location, null, location => /*#__PURE__*/React__default["default"].createElement(Executor, Object.assign({}, location, {
    onRouteChange: onRouteChange
  })));
};

exports.Tracker = Tracker;
